//https://html.spec.whatwg.org/multipage/custom-elements.html#custom-elements-core-concepts

export const ABNORMAL_TAGS: string[] = [
  "annotation-xml",
  "color-profile",
  "font-face",
  "font-face-src",
  "font-face-uri",
  "font-face-format",
  "font-face-name",
  "missing-glyph",
];
